@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '../components/steps/StepLanding/index.scss';
@import '../components/steps/StepUserDataForm/index.scss';
@import '../components/steps/StepVehicleForm/index.scss';
@import '../components/steps/StepVehicleSelect/index.scss';

.mt-Landing-InstantOffer-navButton {
  @include media-breakpoint-up(m) {
    margin-right: $m-m;
  }
}
